export enum GiftCardGateway {
  INCOMM = 1,
  WeGift = 6,
}
export const GiftCardGateways = {
  [GiftCardGateway.INCOMM]: 'InComm',
  [GiftCardGateway.WeGift]: 'WeGift',
};
